// pages/businessOnboarding.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepIndicator from '../components/businessOnboarding/stepIndicator';
import BusinessInfo from '../components/businessOnboarding/businessInfo';
import CreateClub from '../components/businessOnboarding/createClub';
import CreateDeal from '../components/businessOnboarding/createDeal';
import DashboardTour from '../components/businessOnboarding/dashboardTour';

const BusinessOnboarding = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [businessData, setBusinessData] = useState({});
  const navigate = useNavigate(); // Add useNavigate for navigation

  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);

  const handleDataUpdate = (data) => {
    setBusinessData({ ...businessData, ...data });
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <BusinessInfo onNext={nextStep} onDataUpdate={handleDataUpdate} />;
      case 2:
        return <CreateClub onNext={nextStep} onPrev={prevStep} onDataUpdate={handleDataUpdate} />;
      case 3:
        return <CreateDeal onNext={nextStep} onPrev={prevStep} onDataUpdate={handleDataUpdate} />;
      case 4:
        return (
          <DashboardTour 
            onComplete={() => {
              console.log('Onboarding completed');
              navigate('/dashboard/club'); // Navigate to dashboard
            }} 
            onPrev={prevStep} 
          />
        );
      default:
        return <BusinessInfo onNext={nextStep} onDataUpdate={handleDataUpdate} />;
    }
  };

  return (
    <div className="kmint container onboarding-container">
      <div className='row'>
        <div className='col-2'></div>
        <div className='col-8'>
          <h1 className="text-center mb-4">Boost Your Business with MintDeals!</h1>
          <p className="text-center mb-4">Join our platform and start offering amazing deals to your customers.<br/>
          As your customers redeem your deals, you gain access to a growing credit line.</p>
          <StepIndicator currentStep={currentStep} />
          <div className="card">
            <div className="card-body">
              {renderStep()}
            </div>
          </div>
        </div>
        <div className='col-2'></div>
      </div>
    </div>
  );
};

export default BusinessOnboarding;
